import { Component, Vue, Prop } from 'vue-property-decorator';
import { DateModel } from './models/date-model';
import { YearModel } from './models/year-model';
import { MonthModel } from './models/month-model';

@Component({})
export class DatepickerComponent extends Vue {

    public value: any;
    public selectedValue: any;
    public minDate: any;
    public formattedMinDate: any;

    @Prop()
    public maxDate: any;

    @Prop()
    public showDp: any;

    public formattedMaxDate: any;

    public weekdaysLabels: string[] = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];

    public weeks: Array<Array<DateModel>> = [];
    public selectedYear: any;
    public selectedMonth: any;

    public moveLeftEnabled: any;
    public moveRightEnabled: any;

    public created() {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();

        this.value = new Date(y, m, 1);
        this.minDate = new Date(y, m, 1);

        if ((typeof this.value) === 'string') {
            this.selectedValue = new Date();
        } else {
            this.selectedValue = this.value as Date;
        }

        if ((typeof this.minDate) === 'string') {
            this.formattedMinDate = new Date(this.minDate);
        } else {
            this.formattedMinDate = this.minDate as Date;
        }

        if ((typeof this.maxDate) === 'string') {
            this.formattedMaxDate = new Date(this.maxDate);
        } else {
            this.formattedMaxDate = this.maxDate as Date;
        }

        this.startDatepicker();
    }

    private startDatepicker() {
        let date: Date = this.selectedValue ? this.selectedValue : new Date();
        date.setHours(0, 0, 0, 0);

        this.selectedYear = new YearModel(date.getFullYear());
        this.selectedMonth = new MonthModel(date.getMonth(),
            this.selectedYear.numeric);

        this.checkArrowsEnable();

        this.setWeeks();
    }

    private setWeeks() {
        this.weeks = [];

        let previousMonth = true, nextMonth = false;
        let startDay = 0;
        let dayNumber = 1;

        for (let wIndex = 0; wIndex < 6; wIndex++) {
            const week: DateModel[] = [];
            startDay = previousMonth ? (startDay - (this.selectedMonth.firstWeekdayInMonth + 7) % 7) : dayNumber;

            if (previousMonth) {
                dayNumber = startDay;
                previousMonth = false;
            }

            for (let day = startDay; day < startDay + 7; day++) {
                let date = new Date(this.selectedYear.numeric, this.selectedMonth.numeric - 1, dayNumber + 1);

                //TODO: Sábado e Domingo ?
                let enabled = (this.formattedMinDate ? date >= this.formattedMinDate : true)
                    && (this.formattedMaxDate ? date <= this.formattedMaxDate : true)
                // && date.getDay() !== 0 && date.getDay() !== 6;
                let selected = date.getTime() === this.selectedValue.getTime();
                let inCurrentMonth = date.getMonth() === this.selectedMonth.numeric - 1;
                //alteração para não apresentar os dias fora do mês
                if(inCurrentMonth === false){
                    week.push({ date: date,
                        day:0,
                        label:'',
                        month: 0,
                        year: 0,
                        isEnabled: false,
                        isSelected: false,
                        isInCurrentMonth: false,
                        isToday:false
                    });
                } else{
                    week.push(new DateModel(date, enabled, selected, inCurrentMonth));
                }
                dayNumber++;
            }

            this.weeks.push(week);
        }

    }

    private getDateModelFromDate(date: Date) {
        let dateModel;
        this.weeks.forEach(week => {
            if(dateModel) {
                return;
            }
            dateModel = week.find(day => day.date.getTime() == date.getTime());
        });

        return dateModel;
    }

    public selectDate(date: DateModel) {
        if (date) {
            this.weeks.forEach(week => week.map(day => day.isSelected = false));
            date.isSelected = true;
            this.selectedValue = date.date;
        }
    }

    public confirmSelectedDate() {
        this.$emit('update:value', this.selectedValue);
        
    }

    public onCloseModalChild() {
        
        if ((typeof this.value) === 'string') {
            this.selectDate(this.getDateModelFromDate(new Date(this.value)));
        } else {
            this.selectDate(this.getDateModelFromDate(this.value as Date));
        }        

        this.$emit('onCloseModal');
    }

    private checkArrowsEnable() {
        const leftDate = new Date(this.selectedYear.numeric,
            this.selectedMonth.numeric - 1, 1); // first day of month
        this.moveLeftEnabled = this.formattedMinDate ? leftDate > this.formattedMinDate : true;

        const rightDate = new Date(this.selectedYear.numeric,
            this.selectedMonth.numeric, 0); // last day of month
        this.moveRightEnabled = this.formattedMaxDate ? rightDate < this.formattedMaxDate : true;
    }

    moveLeft() {
        if (this.selectedMonth.numeric == 1) {
            this.selectedYear = new YearModel(this.selectedYear.numeric - 1);
            this.selectedMonth = new MonthModel(11,
                this.selectedYear.numeric);
        } else {
            this.selectedMonth = new MonthModel(this.selectedMonth.numeric - 2,
                this.selectedYear.numeric);
        }

        this.setWeeks();
        this.checkArrowsEnable();
    }

    moveRight() {
        if (this.selectedMonth.numeric == 12) {
            this.selectedYear = new YearModel(this.selectedYear.numeric + 1);
            this.selectedMonth = new MonthModel(0,
                this.selectedYear.numeric);
        } else {
            this.selectedMonth = new MonthModel(this.selectedMonth.numeric,
                this.selectedYear.numeric);
        }

        this.setWeeks();
        this.checkArrowsEnable();
    }

    public closeDatePicker(){
        this.$emit('fechaCalendario');
    }
}